import type { IMarketplace } from './types';

export const getSelectMarketplaceIdValues = (options: IMarketplace[]) => {
  let selectedMarketplaceIds = options?.map((option) => option?.value);

  if (selectedMarketplaceIds?.length === 0) {
    return [];
  } else if (selectedMarketplaceIds?.length > 1) {
    selectedMarketplaceIds = selectedMarketplaceIds.filter((e) => e !== 'All');
  }

  return selectedMarketplaceIds;
};

export const getSelectedMarketplaceGroupValue = (options: IMarketplace[], valueArr: string[]) => {
  const selectedMarketplaceGroupOptions: IMarketplace[] = [];

  for (const marketplaceId of valueArr) {
    let option = searchOptions(options, marketplaceId);

    if (option?.options && option.options.length > 0) {
      option = searchOptions(option?.options, marketplaceId);
    }

    option && selectedMarketplaceGroupOptions.push(option);
  }
  return selectedMarketplaceGroupOptions;
};

const searchOptions = (
  options: IMarketplace[],
  marketplaceId: string,
): IMarketplace | undefined => {
  return options.find((option) => {
    if (option?.options) {
      return option?.options?.find((groupOption) => groupOption?.value === marketplaceId);
    } else {
      return option?.value === marketplaceId;
    }
  });
};
